<template>
  <div class="cmi-product-view" v-if="basketCount != 0">
    <div class="panel panel-primary">
      <div class="panel-heading">
        <h2>Shopping Basket</h2>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-8">
            <div class="row clearfix-res">
              <transition-group
                name="animate-resource"
                @afterEnter="itemAfterEnter"
                enter-active-class="animated lightSpeedIn"
                leave-active-class="animated zoomOut"
              >
                <div
                  v-for="item in getBasket"
                  v-bind:key="item.pkey"
                  class="col-sm-6"
                >
                  <div class="widget cmi-widget">
                    <div
                      class="sermon-widget"
                      v-bind:data-showplayer="
                        item.res_PriceType == 1 || item.res_IntroFilePath
                      "
                    >
                      <div class="sermon-img">
                        <img
                          v-bind:src="item.res_FileThumbnailPath"
                          alt="audio cover image"
                        />
                        <span
                          ><i class="fa fa-calendar-o"></i
                          >{{ item.res_MessageLabel }}</span
                        >
                        <h3>
                          <a href="#" title="">{{ item.res_Person }}</a>
                        </h3>
                      </div>
                      <div class="sermon-detail">
                        <p class="sermon-description">
                          <span class="sermon-title">Date: </span
                          ><span class="sermon-text">{{
                            item.res_MessageDate
                          }}</span>
                        </p>
                        <p class="sermon-description">
                          <span class="sermon-title">Event: </span
                          ><span class="sermon-text">{{ item.res_Event }}</span>
                        </p>
                        <p class="sermon-description">
                          <span class="sermon-title">Title: </span
                          ><span class="sermon-text">
                            {{ item.res_MessageTitle }}</span
                          >
                        </p>
                        <p class="sermon-description">
                          <span class="sermon-title">Series: </span>
                          <span class="sermon-text">{{
                            item.res_MessageGenre
                          }}</span>
                        </p>
                        <p class="sermon-description">
                          <span class="sermon-title">Audio file name: </span
                          ><span class="sermon-text">{{
                            item.res_FileName
                          }}</span>
                        </p>
                        <p class="sermon-description">
                          <span class="sermon-title">Item ID: </span
                          ><span class="sermon-text">{{ item.resCode }}</span>
                        </p>
                        <div
                          v-if="
                            item.res_PriceType == 2 && item.res_IntroFilePath
                          "
                          class="cmi-sermon-free"
                        >
                          <div class="audio-preview-title-wrapper">
                            <span class="audio-preview-title"
                              >Audio preview</span
                            >
                          </div>
                          <div class="cmi-sermon-player-wrapper">
                            <audio
                              class="cmi-audio-player"
                              v-bind:src="item.res_IntroFilePath"
                            ></audio>
                          </div>
                        </div>
                        <div class="cmi-sermon-purchase">
                          <div class="cmi-price-wrapper">
                            <span class="cmi-price badge">{{
                              item.res_PriceLabel
                            }}</span>
                          </div>
                          <div class="cmi-item-remove">
                            <button
                              @click="removeFromBasketLocal(item)"
                              type="button"
                              class="btn btn-primary btn-lg"
                            >
                              <span class="fa fa-trash-o"></span
                              ><span class="cmi-basket-item-remove-text"
                                >Remove</span
                              >
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition-group>
            </div>
          </div>
          <div class="col-md-4">
            <p class="cmi-basket-info">
              Please note: During Payment, you will be required to enter your
              E-mail address and card details. Check and be sure that your
              E-mail address is correct. If your payment is accepted, you will
              automatically receive e-mail link to download your ordered audio
              files.
            </p>
            <div v-if="showAnimation" class="cc-animation">
              <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><br />
              <span class="cmi-ani-progress">checkout in progress</span>
            </div>
            <p class="cmi-basket-total">
              <span>{{ basketCount }}</span> Item(s), Total
              <span>$ {{ basketTotal }}</span>
            </p>
            <div class="cmi-shop-checkout">
              <button
                @click="checkout"
                v-bind:disabled="showAnimation"
                type="button"
                class="btn btn-primary btn-lg"
              >
                <span class="fa fa-credit-card"></span
                ><span class="cmi-checkout-text">Proceed to payment</span>
              </button>
            </div>
            <div class="stipe-badge-wrapper">
              <img
                class="stipe-badge"
                src="/dist/assets/stripe/powered_by_stripe.png"
              />
            </div>
            <div class="cmi-card-icons">
              <div class="row">
                <div class="col-sm-4 col-xs-6">
                  <img
                    class="img-responsive"
                    alt="We accept Visa"
                    title="We accept Visa"
                    src="/dist/assets/CardLogos/1.png"
                  />
                </div>
                <div class="col-sm-4 col-xs-6">
                  <img
                    class="img-responsive"
                    alt="We accept MasterCard"
                    title="We accept MasterCard"
                    src="/dist/assets/CardLogos/2.png"
                  />
                </div>
                <div class="col-sm-4 col-xs-6">
                  <img
                    class="img-responsive"
                    alt="We accept American Express"
                    title="We accept American Express"
                    src="/dist/assets/CardLogos/22.png"
                  />
                </div>
                <div class="col-sm-4 col-xs-6">
                  <img
                    class="img-responsive"
                    alt="We accept JCB"
                    title="We accept JCB"
                    src="/dist/assets/CardLogos/16.png"
                  />
                </div>
                <div class="col-sm-4 col-xs-6">
                  <img
                    class="img-responsive"
                    alt="We accept Discover"
                    title="We accept Discover"
                    src="/dist/assets/CardLogos/14.png"
                  />
                </div>
                <div class="col-sm-4 col-xs-6">
                  <img
                    class="img-responsive"
                    alt="We accept Diners Club International"
                    title="We accept Diners Club International"
                    src="/dist/assets/CardLogos/10.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <modal
        name="alert-dialog-basket"
        :width="300"
        :height="'auto'"
        :clickToClose="false"
      >
        <div class="panel-primary">
          <div class="panel-heading modal-alert-heading">
            <span class="modal-alert-title">Information</span>
            <button
              @click="closeAlertDialog"
              type="button"
              class="close pull-right"
            >
              <span
                class="fa fa-times-circle modal-alert-close-button-icon"
              ></span>
            </button>
          </div>
          <div class="panel-body modal-alert-body">
            <div class="modal-alert-text-wrapper">
              <span class="fa fa-exclamation-circle modal-alert-icon"></span>
              <span class="modal-alert-text">
                {{ alertMessage }}
              </span>
            </div>
            <div class="modal-alert-footer">
              <button
                @click="closeAlertDialog"
                type="button"
                class="btn btn-primary"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
import axios from "axios";
export default {
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      fdata: {
        amount: null,
        id: "",
        clientSecret: "",
        items: []
      },
      showAnimation: false,
      alertMessage: ""
    };
  },
  methods: {
    ...mapMutations(["removeFromBasket", "showPayment", "setPaymentIntent"]),
    initialisePayment: async function() {
      this.showAnimation = true;
      let rData = null;
      let actionUrl = `${this.baseUrl}InitialisePayment`;
      try {
        ({ data: rData } = await axios.post(actionUrl, this.fdata));
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }
      if (rData.status == 0) {
        let d = rData.data;
        this.fdata.id = d.id;
        this.fdata.clientSecret = d.clientSecret;
        this.fdata.amount = d.amount;
        this.setPaymentIntent(this.fdata);
      } else {
        this.alertMessage =
          "Sorry checkout has encountered unexpected technical issues, please try again later";
        this.$modal.show("alert-dialog-basket");
      }
      this.showAnimation = false;
    },

    checkout: async function() {
      let amount = this.basketTotal;
      this.fdata.items = this.getBasket.map(p => p.pkey);
      if (!this.fdata.id) {
        this.fdata.amount = amount;
        await this.initialisePayment();
      } else if (this.fdata.id && this.fdata.amount != amount) {
        this.fdata.clientSecret = ""; //don't send clientSecret back to server
        this.fdata.amount = amount;
        await this.initialisePayment();
      } else if (this.fdata.id && this.fdata.amount == amount) {
        this.showPayment(true);
      }
    },
    removeFromBasketLocal: function(item) {
      if (this.$store.state.basket.some(p => p.pkey == item.pkey)) {
        this.removeFromBasket(item);
      }
    },
    closeAlertDialog: function() {
      this.$modal.hide("alert-dialog-basket");
    },
    itemAfterEnter: function(el) {
      let pt = window
        .$(el)
        .find(".sermon-widget")
        .data("showplayer");
      if (pt == true) {
        window
          .$(el)
          .find(".cmi-audio-player")
          .mediaelementplayer();
      }
    }
  },
  computed: {
    ...mapGetters(["basketCount", "basketTotal", "getBasket"])
  },
  async mounted() {
    window.$(".cmi-audio-player").mediaelementplayer();
  }
};
</script>
